import * as React from 'react';
import classNames from 'classnames';
import * as styles from './styles.css';

import { TooltipDesktop } from '@cian/ui-kit';
import { WorkHonestlyTooltip } from '../WorkHonestlyTooltip';

export interface IWorkHonestlyProps {
  levelNumber?: number | null;
  levelName?: string | null;
}

export const WorkHonestly = ({ levelNumber, levelName }: IWorkHonestlyProps) => {
  if (!levelNumber || levelNumber < 3) {
    return null;
  }

  return (
    <TooltipDesktop
      title={<WorkHonestlyTooltip levelNumber={levelNumber} levelName={levelName} />}
      theme="white"
      placement="right-start"
    >
      <div className={classNames(styles['title-icon'], styles[`title-icon-${levelNumber}`])} />
    </TooltipDesktop>
  );
};
